import React from 'react';
import { FiLogIn } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import './styles.css';

import logo from '../../assets/logo.svg';

const Home = () => {
  return (
    <div id="page-home">
      <div className="content">
        <header>
          <img src={logo} alt="Buger Eats" width="200px" />
        </header>

        <main>
          <h1>Seja um parceiro entregador pela Buger Eats</h1>
          <p>Em vez de oportunidades tradicionais de entrega de refeições em horários pouco flexíveis, seja seu próprio chefe.</p>

          <Link to="/deliver">
            <span>
              <FiLogIn />
            </span>
            <strong>Cadastre-se para fazer entregas</strong>
          </Link>
        </main>
      </div>
    </div>
  )
}

export default Home;